import { useState, useEffect } from 'react';
import { HiRefresh, HiX } from 'react-icons/hi';

const ReloadPrompt = () => {
  const [offlineReady, setOfflineReady] = useState(false);
  const [needRefresh, setNeedRefresh] = useState(false);
  const [swRegistration, setSwRegistration] = useState(null);

  useEffect(() => {
    // Only run in production or when service worker is available
    if ('serviceWorker' in navigator) {
      // Listen for service worker updates
      const handleControllerChange = () => {
        setNeedRefresh(true);
      };

      navigator.serviceWorker.addEventListener('controllerchange', handleControllerChange);

      // Check if already registered
      navigator.serviceWorker.ready.then((registration) => {
        setSwRegistration(registration);
        console.log('SW Ready:', registration);

        // Check for updates periodically
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000); // Check every hour
      });

      // Listen for offline ready message
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data && event.data.type === 'OFFLINE_READY') {
          setOfflineReady(true);
        }
      });

      return () => {
        navigator.serviceWorker.removeEventListener('controllerchange', handleControllerChange);
      };
    }
  }, []);

  const close = () => {
    setOfflineReady(false);
    setNeedRefresh(false);
  };

  const updateServiceWorker = () => {
    if (swRegistration && swRegistration.waiting) {
      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  if (!offlineReady && !needRefresh) {
    return null;
  }

  return (
    <div className="fixed bottom-4 right-4 z-50">
      <div className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 max-w-sm">
        {offlineReady ? (
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="h-10 w-10 bg-green-100 rounded-full flex items-center justify-center">
                <svg className="h-6 w-6 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-medium text-gray-900">App ready for offline use</h3>
              <p className="mt-1 text-sm text-gray-500">
                WTF Gyms is now available offline.
              </p>
            </div>
            <button
              onClick={close}
              className="flex-shrink-0 text-gray-400 hover:text-gray-600"
            >
              <HiX className="h-5 w-5" />
            </button>
          </div>
        ) : (
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0">
              <div className="h-10 w-10 bg-blue-100 rounded-full flex items-center justify-center">
                <HiRefresh className="h-6 w-6 text-blue-600" />
              </div>
            </div>
            <div className="flex-1">
              <h3 className="text-sm font-medium text-gray-900">Update available</h3>
              <p className="mt-1 text-sm text-gray-500">
                A new version of the app is available.
              </p>
              <div className="mt-3 flex space-x-2">
                <button
                  onClick={updateServiceWorker}
                  className="inline-flex items-center px-3 py-1.5 border border-transparent text-xs font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700"
                >
                  Update now
                </button>
                <button
                  onClick={close}
                  className="inline-flex items-center px-3 py-1.5 border border-gray-300 text-xs font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50"
                >
                  Later
                </button>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default ReloadPrompt;
